export default __webpack_public_path__ + "static/media/carousel-item-03.fa6ccd75.jpg";